module.exports = __webpack_public_path__ + "img/case12.7bf8dac2.png";